var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isDraft)?_c('div',[_c('message-preview-draft',{attrs:{"index":_vm.index,"action":_vm.action}})],1):_c('div',[_c('message-preview',{attrs:{"index":_vm.index,"action":_vm.action}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }